/**
 * Hook pour les notifications Tracking.
 */
import { useCallback } from "react";
import useSWR from "swr";
import { useAuthentication } from "./useAuthentication";
import {
  fetchTrackingNotifications,
  markNotificationRead as markReadApi,
  type TrackingNotification,
} from "../services/tracking/notificationsService";

const NOTIFICATIONS_KEY = "tracking-notifications";

export function useTrackingNotifications() {
  const { user } = useAuthentication();
  const token = user?.auth?.access_token;

  const { data: notifications, error, isLoading, mutate } = useSWR<TrackingNotification[]>(
    token ? [NOTIFICATIONS_KEY, token] : null,
    () => fetchTrackingNotifications(token),
    { revalidateOnFocus: true }
  );

  const markAsRead = useCallback(
    async (notificationId: string) => {
      await markReadApi(token, notificationId);
      await mutate();
    },
    [token, mutate]
  );

  const refetch = useCallback(() => mutate(), [mutate]);

  return {
    notifications: notifications ?? [],
    isLoading,
    error,
    refetch,
    markAsRead,
    accessToken: token,
  };
}

export type { TrackingNotification };
